import { useEffect, useState } from "react";
import { useUpdate, useUpdateEffect } from "react-use";

type Listener =  () => any;
type Constructor<I> = new (...args: any[]) => I;

export class ClassState {
  private listeners: Set<Listener> = new Set<Listener>();
  public readonly update = () => {
    this.listeners.forEach((listener) => listener());
  }

  public readonly addListener = (listener: Listener) => {
    this.listeners.add(listener);
  }

  public readonly removeListener = (listener: Listener) => {
    this.listeners.delete(listener);
  }

}

export function useClassUpdate<Target extends ClassState>(state: Target) {
  const update = useUpdate();
  useEffect(() => {
    state.addListener(update);
    return () => {
      state.removeListener(update);
    }
  }, [state]);
}

export function useClassState<Target extends ClassState, Args extends ConstructorParameters<Constructor<Target>>>(TargetClass: Constructor<Target>, args: Args) {
  const [state, setState] = useState<Target>(() => new TargetClass(...args));
  useUpdateEffect(() => setState(() => new TargetClass(...args)), args)
  useClassUpdate(state);
  return state;
}

export default useClassState;
